<ion-header class="option-type-popup-header toolbar-no-padding">
  <app-header [pageName]="'SELECT_OPTION' | translate">
    <!-- <ion-buttons end>
      <ion-button slot="icon-only" fill="clear" (click)="onClose()" class="ion-padding-left">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons> -->
  </app-header>
</ion-header>

<div class="option-type-popup-content">
  <ion-list>
    <div class="form_one_button" *ngFor="let result of results; index as i ">
      <ion-button
        expand="full"
        color="eprintprimary"
        (click)="selectOption(i)"
        [attr.data-cy]="result+'JobOptionBtn'"
      >
        {{ result }}
      </ion-button>
    </div>
  </ion-list>
</div>
